// Renders WhatsApp message text the way WhatsApp shows it: *bold*, _italic_,
// ~strikethrough~ and line breaks. Without this the thread printed the markers as
// literal characters ("*Manoj Warule*"), for incoming messages and templates alike.
const WA_MARKUP = /(\*[^*\n]+\*|_[^_\n]+_|~[^~\n]+~)/g;

export default function WaText({ text, className = "" }) {
  const parts = String(text || "").split(WA_MARKUP);
  return (
    <div className={`whitespace-pre-wrap break-words ${className}`}>
      {parts.map((part, i) => {
        if (part.length > 2) {
          const inner = part.slice(1, -1);
          if (part[0] === "*" && part.endsWith("*")) return <strong key={i}>{inner}</strong>;
          if (part[0] === "_" && part.endsWith("_")) return <em key={i}>{inner}</em>;
          if (part[0] === "~" && part.endsWith("~")) return <s key={i}>{inner}</s>;
        }
        return part;
      })}
    </div>
  );
}
